import React from 'react';
import { Div, Divider, FlexRow } from '../../core/Containers';
import { Text } from '../../core/Text';

export const RemittanceHistorySummary = ({
  referenceId,
  depositedDate,
  amount,
}) => (
  <>
    <FlexRow className="items-start justify-between w-full">
      <Div className="w-1/2 px-2">
        <Text className="text-red-400 text-xs font-semibold">
          Date Deposited
        </Text>
        <Text className="text-secondary-200 text-xs">{referenceId}</Text>
      </Div>
      <Div className="w-1/2 px-2">
        <Text className="text-secondary-100 text-xs text-right font-semibold">
          {depositedDate}
        </Text>
        <Text className="text-green-100 text-xs text-right">
          &#8369;{' '}
          {amount
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        </Text>
      </Div>
    </FlexRow>
    <Divider className="text-grey-400 my-5" />
  </>
);

export const RemittanceDataTableRow = ({ data }) => (
  <>
    <FlexRow className="items-center justify-between w-full py-2 hover:bg-grey-400">
      <Text className="text-secondary-100 text-sm w-1/7 px-4">
        {data.depositedDate}
      </Text>
      <Text className="text-secondary-100 text-sm text-center w-1/7 px-4">
        {data.paymentDetails}
      </Text>
      <Text className="text-secondary-100 text-sm text-center w-1/7 px-4">
        {data.tracking}
      </Text>
      <Text className="text-secondary-100 text-sm text-center w-1/7 px-4">
        {data.paymentTracking}
      </Text>
      <Text className="text-secondary-100 text-sm text-center w-1/7 px-4">
        {data.deliveryDate}
      </Text>
      <Text className="text-secondary-100 text-sm text-center w-1/7 px-4">
        {data.serviceMode}
      </Text>
      <Text className="text-secondary-100 text-sm text-center w-1/7 px-4">
        {data.amount}
      </Text>
    </FlexRow>
  </>
);

export const RemittanceDetailsReportsDataTableRow  = ({ data, status}) => (
  <>
    <FlexRow className="items-start justify-between w-3000px py-2 hover:bg-grey-400">
      <Text className="text-secondary-100 text-sm w-200px px-4">
        {data.tracking}
      </Text>
      <Text className="text-secondary-100 text-sm w-200px px-4">
        {data.encodedDate}
      </Text>
      <Text className="text-secondary-100 text-sm w-300px px-4">
        {data.consigneeName}
      </Text>
      <Text className="text-secondary-100 text-sm w-200px px-4">
        {data.consigneeContact}
      </Text>
      <Text className="text-secondary-100 text-sm w-300px px-4">
        {data.consigneeAddress}
      </Text>
      <Text className="text-secondary-100 text-sm w-300px px-4">
        {data.status}
      </Text>
      <Text className="text-secondary-100 text-sm w-200px px-4">
        {data.statusDate}
      </Text>
      <Text className="text-secondary-100 text-sm w-300px px-4">
        {data.acceptanceDate}
      </Text>
      <Text className="text-secondary-100 text-sm w-200px px-4">
        {parseFloat(data.DeclareValue).toLocaleString()}
      </Text>
      <Text className="text-secondary-100 text-sm w-200px px-4">
        {parseFloat(data.collectedAmount).toLocaleString()}
      </Text>
      <Text className="text-secondary-100 text-sm w-200px px-4">
        {parseFloat(data.TotalFreight).toLocaleString()}
      </Text>
      <Text className="text-secondary-100 text-sm w-200px px-4">
        {data.disbursementMode}
      </Text>
      <Text className="text-secondary-100 text-sm w-200px px-4">
        {data.Remarks}
      </Text>
    </FlexRow>
    {/* <FlexRow className="items-center justify-between w-2800px py-2 hover:bg-grey-400">
      <Text className="text-secondary-100 text-sm w-200px px-4">
        {data.tracking}
      </Text>
      <Text className="text-secondary-100 text-sm text-center w-300px px-4">
        {data.encodedDate}
      </Text>
      <Text className="text-secondary-100 text-sm text-center w-300px px-4">
        {data.consigneeName}
      </Text>
      <Text className="text-secondary-100 text-sm text-center w-200px px-4">
        {data.consigneeContact}
      </Text>
      <Text className="text-secondary-100 text-sm text-center w-400px px-4">
        {data.consigneeAddress}
      </Text>
      <Text className="text-secondary-100 text-sm text-center w-200px px-4">
        {data.status}
      </Text>
      <Text className="text-secondary-100 text-sm text-center w-400px px-4">
        {data.statusDate}
      </Text>
      <Text className="text-secondary-100 text-sm text-center w-200px px-4">
        {data.acceptanceDate}
      </Text>
      <Text className="text-secondary-100 text-sm text-center w-200px px-4">
        {parseFloat(data.DeclareValue).toLocaleString()}
      </Text>
      <Text className="text-secondary-100 text-sm text-center w-200px px-4">
        {parseFloat(data.collectedAmount).toLocaleString()}
      </Text>
      <Text className="text-secondary-100 text-sm text-center w-200px px-4">
        {parseFloat(data.TotalFreight).toLocaleString()}
      </Text>
      <Text className="text-secondary-100 text-sm text-center w-200px px-4">
        {data.disbursementMode}
      </Text>
      <Text className="text-secondary-100 text-sm text-center w-200px px-4">
        {data.Remarks}
      </Text>
    </FlexRow> */}
  </>
);